import React from "react";
import { Box, Checkbox, FormControlLabel } from "@mui/material";

export const FilterCheckbox = ({
  isPhaseChecked,
  isTreatmentChecked,
  isCitationChecked,
  isExerciseChecked,
  isLifeStyleChecked,
  isEstimationChecked,
  onPhaseChange,
  onTreatmentChange,
  onCitationChange,
  onExerciseChange,
  onLifeStyleChange,
  onEstimationChange,
}) => {
  return (
    <Box
      display={{ xs: "none", md: "flex" }}
      flexDirection={"column"}
      sx={{ px: 4 }}
    >
      <FormControlLabel
        control={
          <Checkbox checked={!!isPhaseChecked} onChange={onPhaseChange} />
        }
        label={"Phases of Care"} // Format filter name
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={!!isTreatmentChecked}
            onChange={onTreatmentChange}
          />
        }
        label={"Treatments"} // Format filter name
      />

      <FormControlLabel
        control={
          <Checkbox checked={!!isCitationChecked} onChange={onCitationChange} />
        }
        label={"Citations"} // Format filter name
      />

      <FormControlLabel
        control={
          <Checkbox checked={!!isExerciseChecked} onChange={onExerciseChange} />
        }
        label={"Exercises"} // Format filter name
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={!!isLifeStyleChecked}
            onChange={onLifeStyleChange}
          />
        }
        label={"Lifestyle Tips"} // Format filter name
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={!!isEstimationChecked}
            onChange={onEstimationChange}
          />
        }
        label={"Good Faith Estimation"} // Format filter name
      />
    </Box>
  );
};
